import moment from "moment";
import APIService from "./API.service";
const queryString = require("query-string");

// Fields Mapping for Attendees CSV File
// const csvFieldsMatch = {
//   Category: "Category",
//   Company: "Company",
//   Country: "Country",
//   Email: "Email",
//   FirstName: "FirstName",
//   JobTitle: "JobTitle",
//   LastName: "LastName",
//   ThirdPartyID: "ThirdPartyID",
// };

class AttendeeService extends APIService {
  searchAttendees(eventId: number, reqBody: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId: eventId,
    };

    return this.call.post(
      `${this.apiUrl}/attendees/search?${queryString.stringify(query)}`,
      JSON.stringify(reqBody)
    );
  }

  getCheckedInAttendees(eventId: number, sessionId: number, keyword?: string) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    // https://dapi.fielddrive.com/rest/eventsessions/8108/scanned-in/attendees?token=3d1af259286dea58a78013258ce6bf4824969b87c1482001afcf5d5a5be9da3d2b813eeac3e4be0d8344d0c5b3709020bd2680c374054eac68b239c8a1a5531b&eventId=1050&includeCompany=true&fieldId=26771
    return this.call.get(
      `${
        this.apiUrl
      }/eventsessions/${sessionId}/scanned-in/attendees?${queryString.stringify(
        query
      )}&eventId=${eventId}&includeCompany=true&searchOnCompanyAndAttendee=${keyword || ""}`
    );
  }

  getEventAttendees(eventId: number, params: any) {
    const query = {
      page: params.page || 0,
      ...(params.limit && { limit: params.limit }),
      eventId: eventId,
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.get(
      `${this.apiUrl}/attendees?${queryString.stringify(query)}`
    );
  }

  // Delete attendee
  delete(attendeeId: number) {
    const token = localStorage.getItem("fielddrive-token");
    return this.call.delete(
      `${this.apiUrl}/attendees/${attendeeId}?token=${token}`
    );
  }

  // Delete all attendees
  deleteAll(eventId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };
    return this.call.delete(
      `${this.apiUrl}/attendees/?${queryString.stringify(query)}`
    );
  }

  // Create a new attendee
  createAttendee(eventId: number, params: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };

    return this.call.post(
      `${this.apiUrl}/attendees?${queryString.stringify(query)}`,
      JSON.stringify(params)
    );
  }

  // Update an existing attendee
  updateAttendee(attendeeId: number, params: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.put(
      `${this.apiUrl}/attendees/${attendeeId}?${queryString.stringify(query)}`,
      JSON.stringify(params)
    );
  }

  // Get one attendee
  getAttendee(attendeeId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.get(
      `${this.apiUrl}/attendees/${attendeeId}?${queryString.stringify(query)}`
    );
  }

  // Invalidate an attendee's QR code
  blockBarcode(
    eventId: number,
    attendeeId: number,
    body: {
      barcode: string;
      kioskInformation: {
        kioskId: string;
        kioskName: string;
        osVersion: string;
        appVersion: string;
        operator: string;
        location: string;
      };
    }
  ) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.put(
      `${
        this.apiUrl
      }/events/${eventId}/attendees/${attendeeId}/blockBarcode?${queryString.stringify(
        query
      )}`,
      body
    );
  }

  // Check in a single attendee
  checkIn(
    eventId: number,
    attendeeId: number,
    checkInDate: moment.Moment,
    kioskInformation: {
      kioskId: string;
      kioskName: string;
      osVersion: string;
      appVersion: string;
      operator: string;
      location: string;
      checkinMode: string;
    }
  ) {
    const query = {
      checkInDate: checkInDate.toISOString(),
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.post(
      `${
        this.apiUrl
      }/events/${eventId}/attendees/${attendeeId}/checkIn?${queryString.stringify(
        query
      )}`,
      kioskInformation
    );
  }

  // Check out a single attendee
  checkOut(
    eventId: number,
    attendeeId: number,
    checkOutDate: moment.Moment,
    kioskInformation: {
      kioskId: string;
      kioskName: string;
      osVersion: string;
      appVersion: string;
      operator: string;
      location: string;
      checkinMode: string;
    }
  ) {
    const query = {
      checkOutDate: checkOutDate.toISOString(),
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.post(
      `${
        this.apiUrl
      }/events/${eventId}/attendees/${attendeeId}/checkOut?${queryString.stringify(
        query
      )}`,
      kioskInformation
    );
  }

  // Import event sessions from csv file
  processEventAttendeesCSV(
    eventId: number,
    filePath: string,
    fieldsMatch: any
  ) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };
    const body = {
      filePath,
      fieldsMatch,
    };
    return this.call.post(
      `${
        this.apiUrl
      }/attendees/processEventAttendeesCSV?${queryString.stringify(query)}`,
      body
    );
  }

  // Create a session reservation for an attendee
  createReservation(
    attendeeId: number,
    eventId: number,
    eventSessionId: number,
    body: any
  ) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
      eventSessionId,
    };

    return this.call.put(
      `${
        this.apiUrl
      }/attendees/${attendeeId}/addSessionReservation?${queryString.stringify(
        query
      )}`,
      JSON.stringify(body)
    );
  }

  // Update an existing, not deleted, session reservation
  updateReservation(eventId: number, sessionReservationId: number, body: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
    };

    return this.call.put(
      `${
        this.apiUrl
      }/attendees/updateSessionReservation/${sessionReservationId}?${queryString.stringify(
        query
      )}`,
      JSON.stringify(body)
    );
  }

  // Remove a session reservation for an attendee
  removeReservation(
    attendeeId: number,
    eventId: number,
    eventSessionId: number
  ) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
      eventSessionId,
    };
    return this.call.put(
      `${
        this.apiUrl
      }/attendees/${attendeeId}/removeSessionReservation?${queryString.stringify(
        query
      )}`
    );
  }

  // Check-out or reset event attendees
  checkoutAttendees(
    eventId: number,
    ids: number[] = [],
    reset: boolean = true
  ) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
      eventId,
      reset,
    };
    return this.call.post(
      `${this.apiUrl}/attendees/checkOutAttendees?${queryString.stringify(
        query
      )}`,
      ids
    );
  }

  checkoutAllAttendees(
    data: any,
    sessionId: number
  ) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.post(
      `${this.apiUrl}/eventsessions/${sessionId}/sessionScans?${queryString.stringify(
        query
      )}`,
      data
    );
  }

  sendActionLogs(eventId:string,filePath:string){
      const query = {
        eventId,
        filePath,
        token: localStorage.getItem("fielddrive-token"),
      };
      return this.call.post(
        `${this.apiUrl}/attendees/processEventAttendeeActionLogsCSV?${queryString.stringify(query)}`
      );
    }
}

export default AttendeeService;
